import { useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader"
import { useEffect, useState } from "react";
import TierAccountService from "../../services/PayementSolde/TierAccountService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableWalletClient from "./DataTableWalletClient";
import DataTableWalletFournisseur from "./DataTableWalletFournisseur";



const WalletFournisseur=({startLoading,stopLoading})=>{
    const navigate = useNavigate();
    
    const [listTiersAccounts, setListTiersAccounts] = useState([]);

    const navigateToAddWalletFournisseur = () => {
      navigate("/addWalletFournisseur");
    };

    useEffect(() => {
        startLoading()
        setListTiersAccounts([])
        TierAccountService.getAllWalletFournisseur(getCurrentUserId()).then((response)=>{
            setListTiersAccounts(response.data)
        }).catch((error)=>{

        }).finally(()=>{
            stopLoading();
        })
    },[])


    return (<div className="content-wrapper" style={{ marginTop: "0" }}>
        <div className="content ">
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-12">
                        <div class="card  mt-3">
                            <div class="card-body">
                                <h5 class="card-title">Ajouter Wallet Fournisseur </h5>

                                <button
                                    class="btn btn-dark  float-right"
                                  onClick={navigateToAddWalletFournisseur}
                                >
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

                {listTiersAccounts.length > 0 && (
                <DataTableWalletFournisseur listTiersAccounts={listTiersAccounts} />
              )}
            </div>
        </div>
    </div>)
}
export default withLoader(WalletFournisseur)